import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "x-dense" }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "body-1 py-2 text-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "bottom-sheet" }
const _hoisted_19 = {
  class: "remote",
  style: {"pointer-events":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip_tag = _resolveComponent("v-chip-tag")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_scroll_x_transition = _resolveComponent("v-scroll-x-transition")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_multiple_free_tagging = _resolveComponent("multiple-free-tagging")!
  const _component_v_btn_ternary = _resolveComponent("v-btn-ternary")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Document = _resolveComponent("Document")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Reconciliation = _resolveComponent("Reconciliation")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_CreateBTChatMessage = _resolveComponent("CreateBTChatMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oss_data_table, {
      modelValue: _ctx.selectedAccountingTransactionKeys,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedAccountingTransactionKeys) = $event)),
      headers: _ctx.headers,
      items: _ctx.accountingTransactions,
      "items-per-page": _ctx.itemPerPage,
      "items-per-page-options": _ctx.itemPerPages,
      "hide-default-footer": _ctx.accountingTransactions.length <= 50,
      loading: _ctx.loading,
      striped: true,
      "x-dense": true,
      height: _ctx.tableHeight,
      "fixed-header": "",
      "fixed-footer": true,
      "virtual-scroll": true,
      "scroll-to-btn-config": {
                up: true,
                down: true,
            },
      "table-hover": true,
      displayRowNumber: true,
      "show-select": _ctx.addCheckBoxColumn,
      "item-key": "index",
      onClickRow: _cache[24] || (_cache[24] = ($event: any) => (_ctx.openAccountingTransaction($event)))
    }, {
      "header.wording": _withCtx(() => [
        (_ctx.tags.length)
          ? (_openBlock(), _createBlock(_component_v_select, {
              key: 0,
              modelValue: _ctx.tag,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tag) = $event)),
              items: _ctx.tags,
              "item-value": "id",
              "hide-details": "",
              "full-width": false,
              density: "compact",
              "item-title": "name"
            }, {
              selection: _withCtx(({ item }) => [
                _createVNode(_component_v_chip_tag, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                    }, _toDisplayString(item.title), 5)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["modelValue", "items"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, " Libellé "))
      ]),
      "item.log": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.getItemLog(item)), 1)
      ]),
      "item.date": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(item.date)), 1)
      ]),
      "item.debit": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.debit, undefined) || ""), 1)
      ]),
      "item.credit": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.credit, undefined) || ""), 1)
      ]),
      "item.paymentDate": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.paymentDate ? _ctx.formatDate(item.paymentDate) : ""), 1)
      ]),
      "item.balance": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.getAccountingTransactionBalance(item) || ""), 1)
      ]),
      "item.lettering": _withCtx(({ item }) => [
        (item.lettering)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              style: _normalizeStyle(_ctx.getLetteringColor(item))
            }, _toDisplayString(item.lettering || ""), 5))
          : _createCommentVNode("", true),
        (item.reconciliationToValidate)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              rounded: "",
              elevation: "0",
              class: "ml-2",
              onClick: _withModifiers(($event: any) => (_ctx.validateReconciliation(item.reconciliationId)), ["stop"]),
              size: "x-small"
            }, {
              default: _withCtx(() => _cache[46] || (_cache[46] = [
                _createTextVNode(" Valider ")
              ])),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (item.reconciliationToValidate)
          ? (_openBlock(), _createBlock(_component_v_btn_icon, {
              key: 2,
              icon: "$oss-eye",
              class: "ml-2",
              onClick: _withModifiers(($event: any) => (_ctx.openAccountingTransaction(item, item.reconciliationId)), ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_scroll_x_transition, null, {
          default: _withCtx(() => [
            (_ctx.candidateToTerminate.find((ctt) => ctt === item))
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  color: "primary",
                  size: "x-small"
                }, {
                  default: _withCtx(() => _cache[47] || (_cache[47] = [
                    _createTextVNode(" Candidat ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      "item.wording": _withCtx(({ item }) => [
        (item.tags)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_v_chip_tag, {
                key: index,
                class: "text mr-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                  }, _toDisplayString(tag.name), 5)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(item.wording + (item.invoiceNumber ? " - " + item.invoiceNumber : "")), 1),
        (_ctx.thirdPartyMode && item.vatDeclarationId)
          ? (_openBlock(), _createBlock(_component_v_chip, {
              key: 1,
              class: "ma-2",
              color: "green",
              variant: "outlined",
              label: "",
              size: "small"
            }, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createTextVNode(" Déclaré ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      "sum.debit": _withCtx(({ sum }) => [
        _createTextVNode(_toDisplayString(_ctx.debitFormatCurrency(sum)), 1)
      ]),
      "sum.credit": _withCtx(({ sum }) => [
        _createTextVNode(_toDisplayString(_ctx.creditFormatCurrency(sum)), 1)
      ]),
      "sum.balance": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.sumBalance), 1)
      ]),
      menu: _withCtx(({ item }) => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              disabled: 
                            !(_ctx.isSelectionOkForLettering || _ctx.isSelectionOkForLetteringWithDelta)
                        ,
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setShowLetteringDialog(false)), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[49] || (_cache[49] = [
                    _createTextVNode("Lettrer")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    (
                                    !_ctx.isSelectionOkForLettering || _ctx.isSelectionOkForLetteringWithDelta
                                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (Écart: " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                        _ctx.leterringSelectedTotalAmount,
                                        undefined,
                                    )) + ") ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_list_item, {
              class: "oss-list-item",
              disabled: !item.lettering,
              onClick: _withModifiers(($event: any) => (_ctx.opendDeleteDialog(item)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[50] || (_cache[50] = [
                    _createTextVNode("Supprimer le lettrage")
                  ])),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createVNode(_component_v_list_item, {
              disabled: !_ctx.selectedAccountingTransactionCount,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openAccountableAccountDialog = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                    _createTextVNode("Modifier le compte")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 2
        }, 1024)
      ]),
      "body.append": _withCtx(() => [
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("th", {
            class: "text-start",
            colspan: _ctx.lastFirstColumnColspan
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_btn_icon, {
                icon: "$oss-duplicate",
                color: "ternary",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.copyToClipboard()), ["stop"])),
                class: "ml-3",
                size: "x-small"
              }),
              _createVNode(_component_multiple_free_tagging, {
                company: _ctx.selectedCompany,
                "company-tags": _ctx.allCompanyTags,
                "selected-accounting-lines": 
                                    _ctx.selectedAccountingTransactionForTagguing
                                ,
                onSelectedTags: _ctx.onMultiTagguingApplied
              }, null, 8, ["company", "company-tags", "selected-accounting-lines", "onSelectedTags"]),
              (_ctx.is471AccountSelected)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 0,
                    disabled: _ctx.disabledWithoutBankTransactionSelection,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
                                    _ctx.showCreateDocumentMessageDialog =
                                        !_ctx.showCreateDocumentMessageDialog
                                )),
                    icon: "$fa-comments"
                  }, null, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_component_AccountableAccount, {
                title: _ctx.subAccountableAccountTitle,
                showLabel: true,
                showValidation: false,
                companyId: _ctx.selectedCompany.id,
                inAccountableAccountType: "Selected",
                embeddedInput: true,
                editAccountableAccount: true,
                inAccountableAccountNames: _ctx.subSelectedAccountableAccounts,
                defineThirdParty: true,
                activateFreeTag: true,
                bankTransactionId: 
                                    _ctx.selectedAccountingTransactionKeys.length === 1
                                        ? _ctx.selectedAccountingTransactionKeys[0].id
                                        : ''
                                ,
                onClose: _ctx.closeAccountableAccount,
                onSelectAccountableAccount: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setAccountableAccount($event))),
                key: _ctx.refreshKey
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_btn_ternary, _mergeProps({
                      class: "ml-2",
                      disabled: _ctx.disabledThirdPartyCompany(),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.miscelleanousAccountableAccount()))
                    }, props), {
                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                        _createTextVNode(" Affecter à un compte ")
                      ])),
                      _: 2
                    }, 1040, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["title", "companyId", "inAccountableAccountNames", "bankTransactionId", "onClose"])),
              (!_ctx.accountableAccountInfo.bnc)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 1,
                    class: "ml-2",
                    onClick: _withModifiers(_ctx.openMiscellaneousOperationDialog, ["stop"]),
                    disabled: _ctx.disabledCreateMO
                  }, {
                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                      _createTextVNode(" OD ")
                    ])),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.openAccountableAccountDialog)
                ? (_openBlock(), _createBlock(_component_AccountableAccount, {
                    key: 2,
                    showLabel: true,
                    needValidation: true,
                    showValidation: false,
                    companyId: _ctx.companyId,
                    accountableAccountReplacementRule: 
                                    _ctx.accountableAccountReplacementRule
                                ,
                    inAccountableAccount: _ctx.accountableAccountInfo,
                    "btn-mode": true,
                    label: 'Modifier le compte',
                    disabled: 
                                    !_ctx.selectedAccountingTransactionCount || !_ctx.enableModification
                                ,
                    thirdParty: _ctx.thirdPartyCompany || _ctx.user,
                    defineThirdParty: true,
                    startOpenDialog: true,
                    onValidated: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validAA($event))),
                    onDialogClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openAccountableAccountDialog = false))
                  }, null, 8, ["companyId", "accountableAccountReplacementRule", "inAccountableAccount", "disabled", "thirdParty"]))
                : _createCommentVNode("", true),
              (!!_ctx.accountableAccountReplacementRule)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 3,
                    class: "ml-2",
                    disabled: 
                                    !_ctx.selectedAccountingTransactionCount || !_ctx.enableModification
                                ,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (
                                    _ctx.containsAutomaticAccountingLines
                                        ? (_ctx.switchToManualConfirmDialog = true)
                                        : (_ctx.openAccountableAccountDialog = true)
                                ))
                  }, {
                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                      _createTextVNode(" Modifier le compte ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.enableThirdPartyCompanyModification)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createVNode(_component_v_btn_ternary, {
                      class: "ml-2",
                      disabled: 
                                        !_ctx.selectedAccountingTransactionCount || !_ctx.enableModification
                                    ,
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.dialogSelectCompany = true), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Modifier le " + _toDisplayString(_ctx.accountableAccountInfo.name.startsWith("401")
                                            ? "fournisseur"
                                            : "client"), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (_ctx.dialogSelectCompany)
                      ? (_openBlock(), _createBlock(_component_oss_dialog, {
                          key: 0,
                          modelValue: _ctx.dialogSelectCompany,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogSelectCompany) = $event)),
                          fullscreen: _ctx.$vuetify.display.mobile,
                          title: 
                                        'Choisissez le ' +
                                        (_ctx.accountableAccountInfo.name.startsWith('401')
                                            ? 'fournisseur'
                                            : 'client')
                                    ,
                          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.thirdPartyCompany = { id: '', name: '', siret: '' })),
                          onValid: _ctx.valid,
                          validDisabled: !_ctx.thirdPartyCompany || !_ctx.thirdPartyCompany.name,
                          validLoading: _ctx.validLoading,
                          width: "800px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_company_table, {
                              modelValue: _ctx.thirdPartyCompany,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.thirdPartyCompany) = $event)),
                              showGenericCompany: 
                                            _ctx.accountableAccountInfo.name.startsWith('401')
                                        ,
                              showSupplierCompanies: 
                                            _ctx.accountableAccountInfo.name.startsWith('401')
                                        ,
                              showConsumerCompany: 
                                            _ctx.accountableAccountInfo.name.startsWith('411')
                                        ,
                              showCustomerCompanies: 
                                            _ctx.accountableAccountInfo.name.startsWith('411')
                                        ,
                              showExistingCompanies: false,
                              parentCompanyId: _ctx.companyId,
                              wizardMode: true
                            }, null, 8, ["modelValue", "showGenericCompany", "showSupplierCompanies", "showConsumerCompany", "showCustomerCompanies", "parentCompanyId"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "fullscreen", "title", "onValid", "validDisabled", "validLoading"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.enableUserModification)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createVNode(_component_v_btn_ternary, {
                      class: "ml-2",
                      disabled: 
                                        !_ctx.selectedAccountingTransactionCount || !_ctx.enableModification
                                    ,
                      onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.userDialog = true), ["stop"]))
                    }, {
                      default: _withCtx(() => _cache[55] || (_cache[55] = [
                        _createTextVNode("Modifier la personne ")
                      ])),
                      _: 1
                    }, 8, ["disabled"]),
                    (_ctx.userDialog)
                      ? (_openBlock(), _createBlock(_component_oss_dialog, {
                          key: 0,
                          modelValue: _ctx.userDialog,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userDialog) = $event)),
                          fullscreen: _ctx.$vuetify.display.mobile,
                          title: 'Choissez une personne',
                          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.user = { id: '', firstname: '', lastname: '' })),
                          onValid: _ctx.valid,
                          validDisabled: !_ctx.user || !_ctx.user.id,
                          validLoading: _ctx.validLoading,
                          width: "800px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SelectUser, {
                              modelValue: _ctx.user,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user) = $event)),
                              companyId: _ctx.companyId
                            }, null, 8, ["modelValue", "companyId"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "fullscreen", "onValid", "validDisabled", "validLoading"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (
                                    !_ctx.accountableAccountInfo.bnc &&
                                    (_ctx.isSelectionOkForLettering ||
                                        _ctx.isSelectionOkForLetteringWithDelta)
                                )
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 6,
                    class: "ml-2",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.setShowLetteringDialog(true)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isSelectionOkForLettering)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Lettrer"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, " Solder (Écart: " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                            _ctx.leterringSelectedTotalAmount,
                                            undefined,
                                        )) + ") ", 1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isIncomingOutgoingPayment && _ctx.isSelectionOkForBNCLettering)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 7,
                    class: "ml-2",
                    onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.setShowLetteringDialog(true)), ["stop"]))
                  }, {
                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                      _createTextVNode(" Rapprocher ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.partialLettering)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 8,
                    class: "ml-2",
                    onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.setShowLetteringDialog(false)), ["stop"])),
                    disabled: !_ctx.enableModification
                  }, {
                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                      _createTextVNode(" Lettrage Partiel ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.massLetteringAllowed)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 9,
                    class: "ml-2",
                    onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.validateAllReconciliations()), ["stop"]))
                  }, {
                    default: _withCtx(() => _cache[58] || (_cache[58] = [
                      _createTextVNode(" Lettrer en masse ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSelectionOKForDeleteLettering && _ctx.enableModification)
                ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                    key: 10,
                    class: "ml-2",
                    onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.setShowDisletteringDialog()), ["stop"]))
                  }, {
                    default: _withCtx(() => _cache[59] || (_cache[59] = [
                      _createTextVNode(" Délettrer ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_5),
          _cache[60] || (_cache[60] = _createElementVNode("th", { class: "text-right" }, [
            _createElementVNode("strong", null, "Totaux")
          ], -1)),
          _createElementVNode("th", _hoisted_10, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(_ctx.totalDebit), undefined)), 1)
          ]),
          _createElementVNode("th", _hoisted_11, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(_ctx.totalCredit), undefined)), 1)
          ]),
          _createElementVNode("th", _hoisted_12, [
            _createElementVNode("strong", {
              style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance))
            }, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance, undefined)), 5)
          ]),
          (_ctx.addEndColumn)
            ? (_openBlock(), _createElementBlock("th", _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "headers", "items", "items-per-page", "items-per-page-options", "hide-default-footer", "loading", "height", "show-select"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.letteringDialog,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.letteringDialog) = $event)),
      title: _ctx.createLetteringTitle,
      onValid: _ctx.createLettering,
      validLoading: _ctx.letteringLoading,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.createLetteringAnswer), 1),
        (_ctx.delta && _ctx.addLetteringDelta)
          ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
              key: 0,
              outlined: "",
              modelValue: _ctx.delta.wording,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delta.wording) = $event)),
              label: "Libellé",
              density: "compact",
              class: "pb-2"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.delta && _ctx.accountableAccounts.length && _ctx.addLetteringDelta)
          ? (_openBlock(), _createBlock(_component_AccountableAccount, {
              key: 1,
              inAccountableAccounts: _ctx.accountableAccounts,
              thirdParty: _ctx.delta.thirdPartyCompany || _ctx.delta.user || _ctx.delta.bankAccount,
              "show-validation": false,
              "hide-details": "",
              "company-id": _ctx.selectedCompany.id,
              "edit-sub-accountable-account": false,
              label: "Compte comptable",
              inputStyle: 'padding: 0',
              editAccountableAccount: true,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.setDeltaAccountableAccount($event))),
              defineThirdParty: true,
              "model-value": _ctx.delta.accountableAccount
            }, null, 8, ["inAccountableAccounts", "thirdParty", "company-id", "model-value"]))
          : _createCommentVNode("", true),
        (_ctx.delta && !_ctx.addLetteringDelta)
          ? (_openBlock(), _createBlock(_component_oss_data_table, {
              key: 2,
              items: _ctx.letteringSelected,
              headers: _ctx.letteringHeaders,
              "show-select": false,
              "footer-props": true
            }, {
              "item.letteringSelect": _withCtx(({ item }) => [
                (item.letteringData.select)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      color: "secondary"
                    }, {
                      default: _withCtx(() => _cache[61] || (_cache[61] = [
                        _createTextVNode("$check")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              "item.wording": _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString(item.wording + (item.invoiceNumber ? " - " + item.invoiceNumber : "")), 1)
              ]),
              "item.amountSigned": _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.debit - item.credit, undefined)), 1)
              ]),
              "item.letteringAmountSigned": _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.letteringData.amountSigned, undefined)), 1)
              ]),
              _: 1
            }, 8, ["items", "headers"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.disletteringDialog,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.disletteringDialog) = $event)),
      title: 'Délettrage',
      onValid: _ctx.deleteLetterings,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[62] || (_cache[62] = [
        _createElementVNode("div", { class: "text-center" }, "Délettrer les lignes sélectionnées ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteLetteringDialog,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.deleteLetteringDialog) = $event)),
      title: 'Suppression du lettrage',
      onValid: _ctx.deleteLettering,
      validLoading: _ctx.deleteLetteringLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[63] || (_cache[63] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le lettrage ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.switchResultDialog,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.switchResultDialog) = $event)),
      title: 'Notification',
      validTitle: 'J\'ai compris',
      onValid: _cache[31] || (_cache[31] = ($event: any) => (_ctx.switchResultDialog = false)),
      width: "800px"
    }, {
      default: _withCtx(() => [
        (
                    _ctx.switchResult &&
                    _ctx.switchResult.accountingLines &&
                    _ctx.switchResult.accountingLines.length === 0
                )
          ? (_openBlock(), _createElementBlock("h3", _hoisted_15, " L'affectation n'a pu être effectuée sur aucune écriture car elle(s) est/sont dans un exercice clos ou elle(s) est/sont lettrée(s) avec des écritures d'un exercice clos "))
          : (_openBlock(), _createElementBlock("h3", _hoisted_16, " L'affectation n'a pu être effectuée sur certaines écriture(s) car elle(s) est/sont dans un exercice clos ou elle(s) est/sont lettrée(s) avec des écritures d'un exercice clos ")),
        _cache[64] || (_cache[64] = _createElementVNode("h4", null, "Intangibilité du bilan d'ouverture", -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showAccountingTransactionDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.showAccountingTransactionDialog,
          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.showAccountingTransactionDialog) = $event)),
          withoutHeader: true,
          transition: "dialog-bottom-transition",
          onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.closeDocRecDialog())),
          height: "100vh",
          width: "100vw",
          "hide-valid": _ctx.showDocument ? true : false
        }, {
          default: _withCtx(() => [
            (_ctx.showDocument)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      style: {"overflow-y":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Document, {
                          mode: 'GeneralLedger',
                          companyId: _ctx.selectedCompany.id,
                          id: _ctx.documentId,
                          "dark-mode": true,
                          onOpenReconciliation: _ctx.openReconciliation,
                          onDeleted: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onDocumentDeleted())),
                          onTaskEnded: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onDocumentUpdated()))
                        }, null, 8, ["companyId", "id", "onOpenReconciliation"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showReconciliation)
              ? (_openBlock(), _createBlock(_component_Reconciliation, {
                  key: 1,
                  mode: 'GeneralLedger',
                  companyId: _ctx.selectedCompany.id,
                  documentId: _ctx.documentId,
                  bankTransactionId: _ctx.bankTransactionId,
                  reconciliationId: _ctx.reconciliationId,
                  onUpdate: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onReconciliationUpdated()))
                }, null, 8, ["companyId", "documentId", "bankTransactionId", "reconciliationId"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_v_container, { class: "controller elevation-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_prev, {
                        disabled: _ctx.previousDisabled(),
                        onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.previous()), ["stop"]))
                      }, null, 8, ["disabled"]),
                      _createVNode(_component_v_btn_next, {
                        disabled: _ctx.nextDisabled(),
                        onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.next()), ["stop"]))
                      }, null, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "hide-valid"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.miscellaneousOperationDialog,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
      title: 'Opération diverse',
      actions: _ctx.actionMiscellaneousOperation,
      width: "90vw"
    }, {
      default: _withCtx(() => [
        (_ctx.miscellaneousOperationDialog)
          ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
              key: 0,
              prefilledRows: _ctx.prefilledRows,
              companyId: _ctx.companyId,
              actions: _ctx.actionMiscellaneousOperation,
              onUpsert: _cache[39] || (_cache[39] = ($event: any) => (_ctx.refresh()))
            }, null, 8, ["prefilledRows", "companyId", "actions"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "actions"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.switchToManualConfirmDialog,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.switchToManualConfirmDialog) = $event)),
      title: 'Mode manuel',
      onValid: _cache[42] || (_cache[42] = ($event: any) => {
                _ctx.openAccountableAccountDialog = true;
                _ctx.switchToManualConfirmDialog = false;
            }),
      width: "550px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[65] || (_cache[65] = [
                _createElementVNode("div", { class: "pt-2 px-4 pb-2" }, " Attention, vous allez modifier des écritures automatiques et passer en mode manuel. ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.alertNonAuthorizedDatesDialog,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.alertNonAuthorizedDatesDialog) = $event)),
      title: "Date non autorisée",
      validTitle: "OK",
      onValid: _cache[44] || (_cache[44] = ($event: any) => {
                _ctx.alertNonAuthorizedDatesDialog = false;
                _ctx.refreshFather();
            }),
      width: "550px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[66] || (_cache[66] = [
                _createElementVNode("div", { class: "pt-2 px-4 pb-2" }, " Pour information, une ou plusieurs lignes n'ont pas été transférées car le compte bancaire comporte une date de clôture des flux antérieure à la date d'écriture. ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_CreateBTChatMessage, {
      active: _ctx.showCreateDocumentMessageDialog,
      "onUpdate:active": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.showCreateDocumentMessageDialog) = $event)),
      companyId: _ctx.selectedCompany.id,
      bankTransactions: _ctx.selectedAccountingBankTransactionKeys,
      onMessageCreated: _ctx.refresh
    }, null, 8, ["active", "companyId", "bankTransactions", "onMessageCreated"])
  ]))
}